import addressCountries from "../assets/countries/nazionalitaForAddress.json";
import ibanCountries from "../assets/countries/nazionalitaForIban.json";
import swaggerClient from "../remote-client";

export default class ProfileServiceImpl {
  updateUserInfo(payload) {
    return new Promise((resolve, reject) => {
      swaggerClient.memberSwaggerClient.then(client => {
        return client.apis.MemberProfile.postMemberInfo(
          {},
          swaggerClient.buildRequest(payload),
          {}
        )
          .then(res => resolve(res))
          .then(error => reject(error));
      });
    });
  }

  callVerifyUserContactData(payload) {
    return new Promise((resolve, reject) => {
      swaggerClient.memberSwaggerClient
        .then(client => {
          return client.apis.MemberProfile.postVerifyMemberWithFiscalCode(
            { fiscalCode: payload.fiscalCode },
            swaggerClient.buildRequest({
              email: payload.email,
              telefono: payload.telefono
            }),
            {}
          );
        })
        .then(res => resolve(res))
        .catch(error => reject(error));
    });
  }

  sendOTPsms(phone) {
    return new Promise((resolve, reject) => {
      swaggerClient.memberSwaggerClient
        .then(client => {
          return client.apis.MemberProfile.postSendOtpSmsWithPhone(
            { phone },
            swaggerClient.buildRequest(),
            {}
          );
        })
        .then(res => resolve(res))
        .catch(error => reject(error));
    });
  }

  sendOTPmail(email) {
    return new Promise((resolve, reject) => {
      swaggerClient.memberSwaggerClient
        .then(client => {
          return client.apis.MemberProfile.postSendOtpEmailWithEmail(
            { email },
            swaggerClient.buildRequest(),
            {}
          );
        })
        .then(res => resolve(res))
        .catch(error => reject(error));
    });
  }

  certifyPhoneOtp({ phone, otp }) {
    return new Promise((resolve, reject) => {
      swaggerClient.memberSwaggerClient
        .then(client => {
          return client.apis.MemberProfile.postCertifyPhoneWithPhoneWithOtp(
            { phone, otp },
            swaggerClient.buildRequest(),
            {}
          );
        })
        .then(res => resolve(res))
        .catch(error => reject(error));
    });
  }

  certifyEmailOtp({ email, otp }) {
    return new Promise((resolve, reject) => {
      swaggerClient.memberSwaggerClient
        .then(client => {
          return client.apis.MemberProfile.postCertifyEmailWithEmailWithOtp(
            { email, otp },
            swaggerClient.buildRequest(),
            {}
          );
        })
        .then(res => resolve(res))
        .catch(error => reject(error));
    });
  }

  setContactChannelEmail() {
    return new Promise((resolve, reject) => {
      swaggerClient.memberSwaggerClient.then(client => {
        return client.apis.MemberProfile.putMemberChannelEmail(
          {},
          swaggerClient.buildRequest(),
          {}
        )
          .then(res => resolve(res))
          .then(error => reject(error));
      });
    });
  }

  setContactChannelPhone() {
    return new Promise((resolve, reject) => {
      swaggerClient.memberSwaggerClient.then(client => {
        return client.apis.MemberProfile.putMemberChannelPhone(
          {},
          swaggerClient.buildRequest(),
          {}
        )
          .then(res => resolve(res))
          .then(error => reject(error));
      });
    });
  }

  changeSendVoucherMode(channelType) {
    return new Promise((resolve, reject) => {
      swaggerClient.memberSwaggerClient.then(client => {
        return client.apis.MemberProfile.putMemberVoucherWithChannelType(
          { channelType },
          swaggerClient.buildRequest(),
          {}
        )
          .then(res => resolve(res))
          .then(error => reject(error));
      });
    });
  }

  callUpdateCertifiedContactsOnSiSalute() {
    return new Promise((resolve, reject) => {
      swaggerClient.memberSwaggerClient
        .then(client => {
          return client.apis.MemberProfile.postUpdateCertifiedContactsOnSiSalute(
            {},
            swaggerClient.buildRequest(),
            {}
          );
        })
        .then(res => resolve(res))
        .catch(error => reject(error));
    });
  }

  updateHomeAddress(payload) {
    return new Promise((resolve, reject) => {
      swaggerClient.memberSwaggerClient.then(client => {
        return client.apis.MemberProfile["postMemberAddressLiving"](
          {},
          swaggerClient.buildRequest(payload),
          {}
        )
          .then(res => resolve(res))
          .catch(error => reject(error));
      });
    });
  }

  updateResidenceAddress(payload) {
    return new Promise((resolve, reject) => {
      swaggerClient.memberSwaggerClient.then(client => {
        return client.apis.MemberProfile["postMemberAddressResidential"](
          {},
          swaggerClient.buildRequest(payload),
          {}
        )
          .then(res => resolve(res))
          .catch(error => reject(error));
      });
    });
  }

  updateWorkAddress(payload) {
    return new Promise((resolve, reject) => {
      swaggerClient.memberSwaggerClient.then(client => {
        return client.apis.MemberProfile["postMemberAddressWork"](
          {},
          swaggerClient.buildRequest(payload),
          {}
        )
          .then(res => resolve(res))
          .then(error => reject(error));
      });
    });
  }

  getAllProvinces() {
    return new Promise((resolve, reject) => {
      swaggerClient.memberSwaggerClient.then(client => {
        return client.apis.Appointment.getProvincesCovered(
          {},
          swaggerClient.buildRequest(),
          {}
        )
          .then(res => {
            let provinces = res.body.coveredList.map(province => {
              let p = province;
              p.province["covered"] = p.covered;
              delete p.covered;
              p.province["bookable"] = p.bookable;
              delete p.bookable;
              p.province["fullyCovered"] = p.fullyCovered;
              delete p.fullyCovered;
              return p.province;
            });
            resolve(provinces);
          })
          .then(error => reject(error));
      });
    });
  }

  updateConsents(payload) {
    return new Promise((resolve, reject) => {
      swaggerClient.memberSwaggerClient.then(client => {
        return client.apis.MemberProfile.postMemberConsents(
          {},
          swaggerClient.buildRequest(payload),
          {}
        )
          .then(res => resolve(res))
          .then(error => reject(error));
      });
    });
  }

  callDownloadInfoPDFFile(payload) {
    return new Promise((resolve, reject) => {
      swaggerClient.memberSwaggerClient.then(client => {
        return client.apis.MemberProfile.getDocumentInformativeWithDocType(
          payload,
          swaggerClient.buildRequest(),
          {}
        )
          .then(res => resolve(res))
          .catch(error => reject(error));
      });
    });
  }

  callGetCities(payload) {
    return new Promise((resolve, reject) => {
      swaggerClient.nestCommonSwaggerClient.then(client => {
        return client.apis.Domain.getCities(
          payload,
          swaggerClient.buildRequest(),
          {}
        )
          .then(res => resolve(res.body.items))
          .catch(error => reject(error));
      });
    });
  }

  callGetMemberPin() {
    return new Promise((resolve, reject) => {
      swaggerClient.memberSwaggerClient.then(client => {
        return client.apis.MemberProfile.getMemberPin(
          {},
          swaggerClient.buildRequest(),
          {}
        )
          .then(res => resolve(res.body))
          .catch(error => reject(error));
      });
    });
  }

  callRegeneratePin() {
    return new Promise((resolve, reject) => {
      swaggerClient.memberSwaggerClient.then(client => {
        return client.apis.MemberProfile.getMemberRegeneratePin(
          {},
          swaggerClient.buildRequest(),
          {}
        )
          .then(res => resolve(res.body))
          .catch(error => reject(error));
      });
    });
  }

  updateIban(payload) {
    return new Promise((resolve, reject) => {
      swaggerClient.memberSwaggerClient.then(client => {
        return client.apis.MemberProfile.postMemberIban(
          {},
          swaggerClient.buildRequest(payload),
          {}
        )
          .then(res => resolve(res))
          .catch(error => reject(error));
      });
    });
  }

  callGetCountriesForIban() {
    return new Promise((resolve, reject) => {
      let itCountry = {
        idNazionalita: 92,
        descrizione: "Italia",
        isoCode: "IT",
        bicSwift: false,
        cifreIban: 27,
        icona: "Italy.png"
      };
      try {
        if (null != ibanCountries) {
          resolve(ibanCountries);
        } else {
          resolve([itCountry]);
        }
      } catch (error) {
        console.log("error retrieving countries for iban", error);
        reject([itCountry]);
      }
    });
  }

  callGetCountriesForAddress() {
    return new Promise((resolve, reject) => {
      let missingCountry = {
        idComune: null,
        descrizione: "MISSING",
        codice: null,
        cap: null
      };
      try {
        if (null != addressCountries) {
          resolve(addressCountries);
        } else {
          resolve([missingCountry]);
        }
      } catch (error) {
        console.log("error retrieving countries for address", error);
        reject([missingCountry]);
      }
    });
  }

  callGetNucleoFamiliareFull(memberId) {
    return new Promise((resolve, reject) => {
      swaggerClient.memberSwaggerClient.then(client => {
        return client.apis.MemberProfile.getMemberInfoNucleoFamiliareWithMemberId(
          { memberId: memberId },
          swaggerClient.buildRequest(),
          {}
        )
          .then(res => {
            resolve(res?.body?.nucleoFamiliare || []);
          })
          .catch(error => reject(error));
      });
    });
  }
}
